export default "__VITE_ASSET__BTcR4k8s__"